<template>
  <div>
    <form enctype="multipart/form-data">
      <div class="dropzone">
        <input
          type="file"
          multiple
          id="uploadInput"
          :name="nomeCampoDeEnvio"
          @change="
            incluiArquivos($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          accept="image/*,.pdf"
        />
        <h3>
          Arraste e solte seu arquivo aqui<br />
          ou<br />
          Clique para selecionar<br />
          <i class="fa fa-address-card fa-3x" aria-hidden="true"></i>
        </h3>
      </div>
    </form>
    <table class="table">
      <tr v-for="arquivo of arquivosPainel" :key="arquivo.name">
        <td class="esquerda">
          <span>
            <i
              class="fa fa-times fa-lg icone-lista arquivo-nao-enviado"
              aria-hidden="true"
              v-show="!arquivo.id"
            >
            </i>
            <i
              class="fa fa-check fa-lg icone-lista arquivo-enviado"
              aria-hidden="true"
              v-show="arquivo.id"
            >
            </i
            >&nbsp;
          </span>
        </td>
        <td>
          {{ arquivo.name }}
        </td>
        <td class="direita">
          <button
            type="button"
            class="icone-lista botao-direita tira-da-lista"
            v-show="podeDeletar"
            @click="deletaArquivo(arquivo)"
          >
            <span>
              <i class="fa fa-trash fa-lg" aria-hidden="true"> </i>
            </span>
          </button>
          <button
            type="button"
            class="icone-lista botao-direita download-arquivo"
            v-show="arquivo.id"
            @click="download(arquivo)"
          >
            <span>
              <i class="fa fa-cloud-download fa-lg" aria-hidden="true"> </i>
            </span>
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UploadArquivos',

  data() {
    return {
      formData: new FormData(),
      arquivosParaEnviar: [],
      arquivosPainel: [],
      nomeCampoDeEnvio: 'arquivos',
    };
  },

  props: {
    api: {
      required: true,
      type: String,
    },
    endPoint: {
      required: true,
      type: String,
    },
    arquivos: {
      required: false,
      type: Array,
    },
    podeDeletar: {
      required: false,
      type: Boolean,
      default: true,
    },
  },

  methods: {
    metodoQueMontaArrayParaEnviar() {
      let todos = [];
      Array.from(Array(listaArquivos.length).keys()).map(item =>
        todos.push(listaArquivos[item]),
      );
    },
    metodoQueMontaFormData() {
      todos.map(item => {
        this.formTeste.append(nomeArquivo, item, item.name);
      });
    },

    voltaEstadoInicial() {
      this.limpaInput();
      this.formData.delete('arquivos');
      if (this.arquivos)
        this.arquivosPainel = this.arquivos.concat(this.arquivosParaEnviar);
    },
    limpaInput() {
      document.querySelector('#uploadInput').value = '';
    },
    reiniciaModal() {
      this.arquivosParaEnviar = [];
      setTimeout(() => {
        this.voltaEstadoInicial();
      }, 600);
    },
    incluiArquivos(nomeArquivo, listaArquivos) {
      try {
        this.validaUploadImagens(listaArquivos);
        this.montaParaEnviar(listaArquivos);
        this.mostraArquivos();
        this.limpaInput();
      } catch (error) {
        this.$root.$refs.toastr.e(error.message, 'Atenção');
      }
    },
    validaUploadImagens(listaArquivos) {
      let listados = [];
      let todos = [];
      let extensoes = [];
      let naoImagem = [];

      Array.from(Array(listaArquivos.length).keys()).map(item =>
        todos.push(listaArquivos[item].name),
      );
      extensoes = todos.map(item => item.substr(-4, 4).toLowerCase());
      naoImagem = extensoes.filter(
        item =>
          item != '.pdf' && item != '.jpg' && item != '.png' && item != 'jpeg',
      );

      if (!todos.length) {
        this.voltaEstadoInicial();
        throw new Error('Nenhum arquivo foi selecionado');
      }
      if (naoImagem.length > 0) {
        this.voltaEstadoInicial();
        throw new Error('Envie somente imagens com extensões JPG, PNG ou PDF');
      }
      listados = this.arquivosPainel.map(item => item.name);
      todos.map(item => {
        if (listados.includes(item)) {
          this.voltaEstadoInicial();
          throw new Error(
            `O arquivo "${item}" já foi enviado. Se necessário, apague e envie novamente.`,
          );
        }
      });
      todos.map(item => {
        if (item.length > 100) {
          this.voltaEstadoInicial();
          throw new Error(
            'O nome dos arquivos devem ter menos de 100 caracteres',
          );
        }
      });
    },
    montaParaEnviar(listaArquivos) {
      Array.from(Array(listaArquivos.length).keys()).map(item =>
        this.arquivosParaEnviar.push(listaArquivos[item]),
      );
    },
    mostraArquivos() {
      this.arquivosPainel = this.arquivos.concat(this.arquivosParaEnviar);
    },
    tiraDaLista(arquivo) {
      let index = this.arquivosParaEnviar.indexOf(arquivo);
      this.arquivosParaEnviar.splice(index, 1);
      this.mostraArquivos();
    },
    montaFormData(nomeArquivo, listaArquivos) {
      listaArquivos.map(item => {
        this.formData.append(nomeArquivo, item, item.name);
      });
    },
    salvaArquivo() {
      this.montaFormData(this.nomeCampoDeEnvio, this.arquivosParaEnviar);
      this.upload(this.formData);
    },
    incluiMaisArquivos() {
      const sentences = [
        {
          id: 1,
          message: 'Deseja enviar mais algum arquivo?',
          bold: false,
        },
      ];

      this.$root.$refs.modal.confirm(sentences, {
        yes: () => {
          return;
        },
        no: () => {
          this.$eventBus.$emit('dispensaUploader');
        },
        title: 'Anexos',
      });
    },
    deletaArquivo(arquivo) {
      if (arquivo.id) {
        const sentences = [
          {
            id: 1,
            message: 'Deseja excluir esse arquivo da sua lista?',
            bold: false,
          },
        ];

        this.$root.$refs.modal.confirm(sentences, {
          yes: () => this.delete(arquivo.id),
          title: 'Deletar Arquivo',
        });
        return;
      }
      this.tiraDaLista(arquivo);
    },

    // Requisições
    upload(formData) {
      const url = this.api + this.endPoint;
      const token = this.$store.state.token;
      if (formData.getAll('arquivos').length) {
        return axios
          .post(url, formData, {
            headers: { Authorization: token },
          })
          .then(response => {
            return response.data;
          })
          .then(res => {
            this.arquivosPainel = this.arquivos.concat(res);
            this.arquivosParaEnviar = [];
            this.$store.commit(
              'setArquivosRecadastramento',
              this.arquivosPainel,
            );
            this.$nextTick(() => this.voltaEstadoInicial());
            this.$eventBus.$emit('dispensaUploader');
            this.$root.$refs.toastr.s('Arquivo enviado', 'Sucesso');
          })
          .catch(error => this.trataErro(error));
      }
    },
    delete(id) {
      const url = this.api + this.endPoint + '/' + id;
      const token = this.$store.state.token;
      axios
        .delete(url, {
          headers: { Authorization: token },
        })
        .then(response => {
          const arquivosRestantes = this.arquivos.filter(
            item => item.id !== id,
          );
          this.$store.commit('setArquivosRecadastramento', arquivosRestantes);
          this.$nextTick(() => this.voltaEstadoInicial());
        })
        .catch(error => this.trataErro(error));
    },
    download(arquivo) {
      const url = this.api + this.endPoint + '/' + arquivo.id;
      const token = this.$store.state.token;
      axios
        .get(url, {
          headers: { Authorization: token },
          responseType: 'blob',
        })
        .then(response => {
          const resUrl = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = resUrl;
          link.setAttribute('download', arquivo.name);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => this.trataErro(error));
    },
    trataErro(error) {
      this.voltaEstadoInicial();
      if (error) {
        this.$root.$refs.toastr.e(error.response.data[0].message, 'Atenção');
        return;
      }
      this.$root.$refs.toastr.e(
        'Algo deu errado, por favor nos avise do ocorrido via SAU',
        'Atenção',
      );
    },
  },

  created() {
    if (this.arquivos) this.arquivosPainel = this.arquivos;

    this.$eventBus.$on('limpa-uploads', () => this.reiniciaModal());
    this.$eventBus.$on('salva-arquivos', () => this.salvaArquivo());
  },

  beforeDestroy() {
    this.$eventBus.$off('limpa-uploads');
    this.$eventBus.$off('salva-arquivos');
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding-left: 6px;
}
td {
  padding-bottom: 10px;
}
td.esquerda,
td.direita {
  padding-left: 6px;
}
.table {
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: 0px;
  max-width: none;
  width: auto;
}
.dropzone {
  background-color: #eeeeee;
  padding: 15px;
  margin-bottom: 20px;
  text-align: center;
  border: 2px dashed #cccccc;
  border-radius: 10px;
}
.dropzone:hover {
  background-color: #e6e8e6;
}
.dropzone input {
  opacity: 0;
  position: absolute;
  width: 75%;
  height: 200px;
  cursor: pointer;
}
.dropzone h3 {
  margin: 15px 0;
  font-size: 1.4em;
  line-height: 1.5em;
}
.dropzone h3 i {
  margin-top: 20px;
}
.icone-lista {
  margin: 0 15px;
  border: none;
  background: none;
}
.botao-direita {
  float: right;
}
.arquivo-nao-enviado {
  color: #cccccc;
}
.arquivo-enviado {
  color: #419641;
}
.download-arquivo {
  color: #707070;
}
.tira-da-lista {
  margin-left: 0;
  color: firebrick;
}

@media screen and (min-width: 520px) {
  .table {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?c901395a